import { gql, NetworkStatus, useQuery } from "@apollo/client";
import { shiftStreamClient } from "../../../graphql/client";

export const GET_STREAM_STATS = gql`
  query getStreamStats($id: Int!) {
    stream(id: $id) {
      id

      stats {
        reservedCount
        appliedCount
        acceptedCount
      }
    }
  }
`;

export const useStreamStats = (id: any | null) => {
  const { data, loading, networkStatus, refetch } = useQuery(GET_STREAM_STATS, {
    client: shiftStreamClient,
    variables: {
      id: parseInt(`${id}`),
    },
    fetchPolicy: "cache-and-network",
    notifyOnNetworkStatusChange: true,
    skip: id === null,
    onError: (error) => {
      throw error;
    },
  });

  return {
    loading: loading || networkStatus === NetworkStatus.refetch,
    stats: data?.stream?.stats || null,
    refetch,
  };
};
